import { Link } from "react-router-dom";
import { useCategories } from "@/context/CategoriesContext";
import { useSettings } from "@/context/SettingsContext";
import SocialLinks from "@/components/SocialLinks";
import { MapPin, Mail, Send } from "lucide-react";

export default function Footer() {
  const { categories } = useCategories();
  const settings = useSettings();

  return (
    <footer className="mt-16 border-t border-slate-200 bg-slate-900 text-slate-300" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 sm:px-6 md:grid-cols-4 lg:px-8">
        <div className="md:col-span-2">
          <span className="font-display text-2xl font-extrabold text-white">
            {(settings.site_title || "Подуяне Днес").toUpperCase()}
          </span>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-400">
            {settings.tagline}
          </p>
          <p className="mt-4 text-xs text-slate-500">
            Сайтът е частен и независим — не е официален канал на общината или
            районната администрация.
          </p>
          <SocialLinks variant="footer" className="mt-6" />
        </div>

        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">
            Рубрики
          </h4>
          <ul className="mt-4 space-y-2 text-sm">
            {categories.map((cat) => (
              <li key={cat.id || cat.slug}>
                <Link
                  to={`/category/${cat.slug}`}
                  className="text-slate-400 transition-colors hover:text-primary"
                >
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">
            Връзка
          </h4>
          <ul className="mt-4 space-y-3 text-sm text-slate-400">
            <li className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-primary" />
              район Подуяне, София
            </li>
            <li className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-primary" />
              {settings.contact_email}
            </li>
            <li>
              <Link
                to="/izprati-signal"
                className="inline-flex items-center gap-1.5 font-medium text-primary hover:underline"
              >
                <Send className="h-4 w-4" />
                Изпрати сигнал
              </Link>
            </li>
            <li>
              <Link to="/obyavi" className="text-slate-400 transition-colors hover:text-primary">
                Обяви
              </Link>
            </li>
            <li>
              <Link to="/obshti-usloviya" data-testid="footer-terms-link" className="text-slate-400 transition-colors hover:text-primary">
                Общи условия
              </Link>
            </li>
            <li>
              <Link to="/poveritelnost" data-testid="footer-privacy-link" className="text-slate-400 transition-colors hover:text-primary">
                Политика за поверителност
              </Link>
            </li>
          </ul>
        </div>
      </div>
      {settings.disclaimer_text && (
        <div className="border-t border-slate-800">
          <div className="mx-auto max-w-7xl px-4 py-4 text-xs leading-relaxed text-slate-400 sm:px-6 lg:px-8" data-testid="footer-disclaimer">
            {settings.disclaimer_text}
          </div>
        </div>
      )}
      <div className="border-t border-slate-800">
        <div className="mx-auto max-w-7xl px-4 py-4 text-center text-xs text-slate-500 sm:px-6 lg:px-8">
          © {new Date().getFullYear()} {settings.site_title}. Всички права запазени.
        </div>
      </div>
    </footer>
  );
}
